<template>
  <header class="landing-header">
    <div class="inner-container">

      <div class="moip-logo">
        <span>Moip | a wirecard company</span>
      </div>

      <ul :id="mobileMenuId" class="menu">
        <li class="menu-item" @click="goToSection" data-target="#inicio">Inicio</li>
        <li class="menu-item" @click="goToSection" data-target="#depoimentos">Depoimentos</li>
        <li class="menu-item" @click="goToSection" data-target="#clientes">Carreira</li>
        <li class="menu-item" @click="goToSection" data-target="#como-trabalhamos">Como Trabalhamos</li>
        <li class="menu-item" @click="goToSection" data-target="#escritorio">Escritório</li>
        <li class="menu-item" @click="goToSection" data-target="#open-source">Open Source</li>
        <li class="menu-item" @click="goToSection" data-target="#vagas">Vagas</li>
      </ul>

      <button class="mobile-menu-button" @click="showMobileMenu">
        <span class="moip-icon moip-icon-bars"></span>
        <span class="hide-me">Menu</span>
      </button>

    </div>
  </header>
</template>

<style lang="less" scoped>
  @import (reference) '../assets/styles/references';

  .landing-header {
    @header-height: 60px;
    @logo-width: 120px;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: @header-height;
    background-color: @white;
    box-shadow: 0 0 5px fade(@dark-blue, 25%),
                0 2px 2px fade(@dark-blue, 20%),
                0 4px 4px fade(@dark-blue, 20%),
                0 8px 8px fade(@dark-blue, 20%),
                0 16px 16px fade(@dark-blue, 20%);

    .inner-container {
      position: relative;
      padding: 0;
    }

    .mobile-menu-button {
      display: none;
      position: absolute;
      font-size: 35px;
      top: 0;
      left: @xs-spacer;
      height: @header-height;
      color: @light-blue-2;
      -webkit-appearance: button; /* for input */
      -webkit-user-select: none; /* for button */
      -moz-user-select: none;
      -ms-user-select: none;
      background: none;
      border: 0;
      padding: 0;
      .hide-me {
        display: none;
      }
    }

    .moip-logo {
      position: absolute;
      top: 0;
      right: 0;
      width: @logo-width;
      height: @header-height;
      background: url(../assets/images/moip-wirecard-color.svg) no-repeat right center;
      background-size: contain;
      span {
        opacity: 0;
      }
    }

    .menu {
      padding: 0;
      padding-right: @logo-width + @md-spacer;
      display: flex;
      height: @header-height;
      justify-content: space-between;
    }

    .menu-item {
      @icon: 8px;
      .reset();
      .transition(color);
      position: relative;
      display: flex;
      align-items: center;
      font-size: @xs-font-size;
      font-weight: @font-weight-bold;
      text-transform: uppercase;
      padding-left: @icon + @xs-spacer/2;
      color: @gray;
      cursor: pointer;

      &:before {
        content: '';
        width: @icon;
        height: @icon;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background-color: @blue;
        border-radius: 50%;
        opacity: 0;
        .transition(opacity);
      }

      &:hover {
        background-color: transparent;
        color: @blue;
        user-select: none;
      }
      &:focus {
        background-color: transparent;
      }
      &.active {
        .transition(color);
        color: @blue;
        &:before {
          .transition(opacity);
          opacity: 1;
        }
      }
    }


    // Responsive
    @media @tablet {
      .moip-logo {
        right: @xs-spacer;
      }
      .mobile-menu-button {
        display: block;
      }
      #show{
        opacity: 1;
        pointer-events: all;
      }
      .menu {
        opacity: 0;
        pointer-events: none;
        transition: visibility 0s, opacity 0.2s linear;
        position: absolute;
        top: @header-height;
        background-color: @white;
        flex-direction: column;
        height: auto;
        padding: @xs-spacer;
        &.active {
          display: block;
        }
      }
      .menu-item {
        cursor: pointer;
        padding: @xs-spacer 0;
        font-size: 1.2em;
        &:before {
          position: relative;
          top: 4px;
          margin-right: 2px;
        }
        &:hover {
          a {
            color: @light-blue-2;
          }
          &:before {
            position: relative;
            top: 4px;
            opacity: 1;
          }
        }
      }
    }
  }
</style>

<script>
  import jump from 'jump.js'

  export default {
    data() {
      return {
        disabled: false,
        itemSelected: '',
        mobileMenuId: ''
      }
    },
    mounted() {
      window.addEventListener('wheel', this.cancelJump, false);
      window.addEventListener('touchstart', this.cancelJump, false);
    },
    beforeDestroy() {
      window.removeEventListener('wheel', this.cancelJump, false);
      window.removeEventListener('touchstart', this.cancelJump, false);
    },
    methods: {
      cancelJump () {
        if (jump.isJumping()) jump.cancel()
      },
      goToSection(ev) {
        this.itemSelected = ev.target.getAttribute('data-target')

        let items = this.$el.querySelectorAll('.menu-item')
        for(let item of items) {
          if (item.getAttribute('data-target') === this.itemSelected) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        }

        jump(this.itemSelected, {offset: -80})
        this.showMobileMenu()
      },
      showMobileMenu() {
        if(this.mobileMenuId === '') {
          this.mobileMenuId = 'show'
          return
        }
        this.mobileMenuId = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LandingHeader.vue?7498c4ac